import get from 'lodash/get'
import { RaRecord, useTranslate } from 'react-admin'
import { FC } from 'react'

export const HeaderTitle: FC<HeaderTitleProps> = (props) => {
  const {
    className,
    i18n,
    record,
    source,
  } = props
  const translate = useTranslate()
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const getSource = source ? get(record, source) as string : undefined

  return getSource ?
    <span className={className}>{translate(i18n, { name: getSource })}</span> :
    <span className={className}>{translate(i18n)}</span>
}

interface HeaderTitleProps {
  className?: string;
  i18n: string;
  record?: RaRecord;
  source?: string;
  [key: string]: any;
}
